/* CardList.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu85zaO%7Bgap%3Avar(--ds-space-200%2C1pc)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._2VgeItyFLW%7Bscroll-margin-block-start%3Avar(--ds-space-1000%2C5pc)%7D%0A._2mHwu8kG2W%7Bgap%3Avar(--ds-space-250%2C20px)%7D%0A._3iDTPbgBM8%7Bdisplay%3Agrid%7D%0A._2iEGP28wUV%7Bgrid-template-columns%3Aminmax(0%2C1fr)%7D%0A._21ioM3IMVv%7Bgrid-auto-rows%3Aminmax(270px%2Cauto)%7D%0A%40media%20(min-width%3A48rem)%7B._3E0AG27s7Z%7Bgrid-template-columns%3Arepeat(2%2Cminmax(0%2C1fr))%7D%7D%0A%40media%20(min-width%3A64rem)%7B._4cQPhCbyVk%7Bgrid-template-columns%3Arepeat(3%2Cminmax(0%2C1fr))%7D%7D%0A%40media%20(min-width%3A90rem)%7B._1YDlQuluOB%7Bgrid-template-columns%3Arepeat(4%2Cminmax(0%2C1fr))%7D%7D%0A._0u2WMmrU95%7Bcontainer-type%3Ainline-size%7D%0A._3n40gW3nxB%7Bcontainer-name%3Abrowse-card-list%7D%0A%40container%20browse-card-list%20(min-width%3A%20700px)%7B._2i1VK67s7Z%7Bgrid-template-columns%3Arepeat(2%2Cminmax(0%2C1fr))%7D%7D%0A%40container%20browse-card-list%20(min-width%3A%20460px)%7B._3eD7N57s7Z%7Bgrid-template-columns%3Arepeat(2%2Cminmax(0%2C1fr))%7D%7D%0A%40container%20browse-card-list%20(min-width%3A%20700px)%7B._2i1VK6byVk%7Bgrid-template-columns%3Arepeat(3%2Cminmax(0%2C1fr))%7D%7D%0A%40container%20browse-card-list%20(min-width%3A%20940px)%7B._2YAQKdluOB%7Bgrid-template-columns%3Arepeat(4%2Cminmax(0%2C1fr))%7D%7D");
















import React, { useEffect, useId, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import Button from '@atlaskit/button/default/button';
import { cx } from '@atlaskit/css';
import type ContainerQuery from '@atlaskit/css/at-rules/container';
import Heading from '@atlaskit/heading/heading';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { StudioBrowseKitIntlProvider } from '../../../i18n/StudioBrowseKitIntlProvider';
import type { CardListProps, GridColumns } from '../../types';
import { messages } from './messages';
const styles = {
  root: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w",
  scrollTarget: "_2VgeItyFLW",
  grid: "_2mHwu8kG2W _3iDTPbgBM8 _2iEGP28wUV",
  upliftGrid: "_21ioM3IMVv",
  columns2: "_3E0AG27s7Z",
  columns3: "_3E0AG27s7Z _4cQPhCbyVk",
  columns4: "_3E0AG27s7Z _4cQPhCbyVk _1YDlQuluOB"
};

// The strict ADS cssMap API does not yet accept container declarations or queries.
const containerStyles = {
  container: "_0u2WMmrU95 _3n40gW3nxB",
  columns2: "_2i1VK67s7Z",
  columns4: "_3eD7N57s7Z _2i1VK6byVk _2YAQKdluOB"
};
const columnStyles = ({
  2: styles.columns2,
  3: styles.columns3,
  4: styles.columns4
} satisfies Record<GridColumns, unknown>);
const upliftColumnStyles = ({
  2: containerStyles.columns2,
  3: styles.columns3,
  4: containerStyles.columns4
} satisfies Record<GridColumns, unknown>);
const CardListContent = ({
  columns = 3,
  collapsedItemCount = columns,
  children,
  emptyState,
  loadingState,
  pagination,
  heading,
  subtitle,
  isCollapsible = false,
  shouldScrollOnExpand = false,
  testId
}: CardListProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const isUplift = expVal('jira_browse_agent_modal_update', 'isEnabled', false);
  const [isExpanded, setIsExpanded] = useState(false);
  const cardListId = useId();
  const listRef = useRef<HTMLDivElement>(null);
  const cards = useMemo(() => React.Children.toArray(children), [children]);
  const canCollapse = isCollapsible && (cards.length > collapsedItemCount || Boolean(pagination));
  const showAdditionalContent = !isCollapsible || isExpanded;
  const visibleCards = useMemo(() => canCollapse && !isExpanded ? cards.slice(0, collapsedItemCount) : cards, [cards, canCollapse, collapsedItemCount, isExpanded]);
  useEffect(() => {
    if (isExpanded && shouldScrollOnExpand) {
      listRef.current?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }, [isExpanded, shouldScrollOnExpand]);
  const showDescription = isUplift && Boolean(subtitle);
  const header = heading || canCollapse ? <Inline alignBlock="center" spread="space-between">
				{heading ? <Heading size="small" as="h2">
						{heading}
					</Heading> : null}
				{canCollapse ? <Button appearance="subtle" spacing="compact" aria-controls={cardListId} aria-expanded={isExpanded} iconAfter={isExpanded ? ChevronUpIcon : ChevronRightIcon} onClick={() => setIsExpanded(currentValue => !currentValue)} testId={testId ? `${testId}--toggle` : undefined}>
						{formatMessage(isExpanded ? messages.showLess : messages.viewAll)}
					</Button> : null}
			</Inline> : null;
  return <div ref={listRef} className={ax([styles.root, isUplift && containerStyles.container, shouldScrollOnExpand && styles.scrollTarget])}>
			{(heading || canCollapse || showDescription) && <Stack space="space.050">
					{header}
					{showDescription && <Text as="p" color="color.text.subtlest">
							{subtitle}
						</Text>}
				</Stack>}
			{cards.length === 0 && !loadingState && !pagination && emptyState !== undefined ? emptyState : <Box id={cardListId} xcss={cx(styles.grid, isUplift ? upliftColumnStyles[columns] : columnStyles[columns], isUplift && styles.upliftGrid)} testId={testId}>
					{visibleCards}
					{showAdditionalContent && loadingState}
				</Box>}
			{showAdditionalContent && pagination}
		</div>;
};
export const CardList = (props: React.ComponentProps<typeof CardListContent>): React.JSX.Element => <StudioBrowseKitIntlProvider>
		<CardListContent {...props} />
	</StudioBrowseKitIntlProvider>;